export default "__VITE_ASSET__DFl$LH7U__"